module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "erco-layout-template-selection"
  }, [(_vm.sets.length > 0) ? _c('div', {
    staticClass: "container"
  }, _vm._l((_vm.sets), function(set) {
    return _c('div', {
      key: set.PKM_Objekt,
      staticClass: "_item",
      on: {
        "click": function($event) {
          _vm.handleSetClick(set)
        }
      }
    }, [_c('b-card', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "text-muted",
      slot: "header"
    }, [_c('span', {
      attrs: {
        "data-infotextkey": _vm.infoTextKeyForSet(set)
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.fixUpperCase(set.S_de_Objekt)) + "\n\t\t\t\t\t\t"), (_vm.infoTextForSet(set)) ? _c('erco-tooltip', {
      attrs: {
        "variant": _vm.infoTextForSet(set).variant,
        "title": _vm.infoTextForSet(set).title,
        "text": _vm.infoTextForSet(set).text
      }
    }) : _vm._e()], 1)]), _vm._v(" "), _c('img', {
      staticClass: "image",
      attrs: {
        "src": _vm.getAbsolutePathForImage(set.S_Vorschaubild_url),
        "alt": ("Vorschaubild für " + (set.S_de_Objekt))
      },
      on: {
        "error": _vm.handleImageError
      }
    })])], 1)
  })) : _c('div', {
    staticClass: "_empty"
  }, [_vm._v("\n\t\tKeine Sets gefunden!\n\t")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1378e8aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/ErcoLayout/TemplateSelection.vue
// module id = 595
// module chunks = 0